import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "visualEditor",
    "htmlEditor",
    "visualModeButton",
    "htmlModeButton",
    "toolbar"
  ]

  static values = { mode: String }

  connect() {
    this.modeValue = this.modeValue || "visual"
    this.syncEditorsFromInput()
    this.applyMode()
  }

  switchToVisual(event) {
    event.preventDefault()
    this.syncInputFromHtml()
    this.modeValue = "visual"
    this.applyMode()
  }

  switchToHtml(event) {
    event.preventDefault()
    this.syncInputFromVisual()
    this.modeValue = "html"
    this.applyMode()
  }

  format(event) {
    event.preventDefault()
    const command = event.currentTarget.dataset.command
    if (!command) return

    document.execCommand(command, false)
    this.syncInputFromVisual()
  }

  syncInputFromVisual() {
    this.inputTarget.value = this.visualEditorTarget.innerHTML
  }

  syncInputFromHtml() {
    this.inputTarget.value = this.htmlEditorTarget.value
  }

  applyMode() {
    const visual = this.modeValue !== "html"

    this.visualEditorTarget.classList.toggle("hidden", !visual)
    this.htmlEditorTarget.classList.toggle("hidden", visual)
    this.toolbarTarget.classList.toggle("hidden", !visual)

    this.visualModeButtonTarget.classList.toggle("bg-cyan-600", visual)
    this.visualModeButtonTarget.classList.toggle("text-white", visual)
    this.visualModeButtonTarget.classList.toggle("text-slate-700", !visual)
    this.visualModeButtonTarget.classList.toggle("dark:text-slate-200", !visual)

    this.htmlModeButtonTarget.classList.toggle("bg-cyan-600", !visual)
    this.htmlModeButtonTarget.classList.toggle("text-white", !visual)
    this.htmlModeButtonTarget.classList.toggle("text-slate-700", visual)
    this.htmlModeButtonTarget.classList.toggle("dark:text-slate-200", visual)

    if (visual) {
      this.visualEditorTarget.innerHTML = this.inputTarget.value || "<p></p>"
    } else {
      this.htmlEditorTarget.value = this.inputTarget.value || ""
    }
  }

  syncEditorsFromInput() {
    this.visualEditorTarget.innerHTML = this.inputTarget.value || "<p></p>"
    this.htmlEditorTarget.value = this.inputTarget.value || ""
  }
}
